import { shallowEqual, useSelector } from 'react-redux'

import { CheckoutBody } from './Checkout.styled'
import { ErrorDisplay } from 'mmfintech-portal-commons'

export const InternalExecutionStep = () => {
  const { checkoutPayError } = useSelector(
    ({ checkout: { checkoutPayError } }) => ({
      checkoutPayError
    }),
    shallowEqual
  )

  return (
    <CheckoutBody>
      <ErrorDisplay error={checkoutPayError} />

      {/* TODO: <InternalPayment session={checkoutPay} /> */}
    </CheckoutBody>
  )
}
